import styled from 'styled-components';

export const Container = styled.span`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const Badges = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.grey6};
  text-decoration: underline;
  font-style: normal;
  font-weight: 350;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.4px;
  -webkit-font-smoothing: antialiased;
  margin: 0;
`;

export const TooltipContent = styled.span`
  color: ${({ theme }) => theme.colors.white};
`;
